module.exports = __webpack_public_path__ + "img/star-level-icon.96916df.png";